<template>
  <section class="client-contacts-filters">
    <div class="section-title">
      <span @click="isOpen = !isOpen">
        {{ $t('clientContacts.listing.filters.title') }}
        <font-awesome-icon :icon="isOpen ? 'sort-up' : 'sort-down'" />
      </span>
    </div>

    <div v-show="isOpen">
      <div class="active-inactive-label">
        <TolSelect
          :options="filters"
          :placeholder="$t('clientContacts.listing.filters.select')"
          :selected="selectedFilter"
          @change="onFilterChange"
        />
      </div>
    </div>
  </section>
</template>

<script>
import TolSelect from '@/app/components/TolSelect';
import { ClientContactsListingGetters } from '../../client-contact-listing/client-contacts-listing.keys';
export default {
  components: {
    TolSelect
  },
  data() {
    return {
      isOpen: false
    };
  },
  computed: {
    filters() {
      let returnValue = [];
      Object.keys(this.$t('clientContacts.listing.filters.activeinactive')).forEach(arg => {
        returnValue.push({
          label: this.$t('clientContacts.listing.filters.activeinactive.' + arg),
          value: arg
        });
      });
      return returnValue;
    },

    selectedFilter() {
      const selectedFilter = this.$store.getters[
        ClientContactsListingGetters.ClientContactActiveInactive
      ];
      let selectedFilterArray = [];
      if (selectedFilter) {
        selectedFilterArray.push({
          label: this.$t('clientContacts.listing.filters.activeinactive.' + selectedFilter),
          value: selectedFilter
        });
      }
      return selectedFilterArray;
    }
  },
  methods: {
    onFilterChange(activeInactive) {
      this.$emit('change', activeInactive);
    }
  }
};
</script>

<style lang="scss" scoped>
@import '../../../../../styles/colors.scss';
@import '../../../../../styles/variables.scss';

.client-contacts-filters {
  background-color: $background-level-2;
  .section-title {
    font-size: 22px;
    font-weight: bold;
    letter-spacing: -0.22px;
    line-height: 25px;
    margin-bottom: 20px;
    padding: 60px;
    display: flex;
    justify-content: space-between;

    > span {
      cursor: pointer;
    }
  }

  .active-inactive-label {
    display: flex;

    padding-left: 60px;
    padding-bottom: 5px;
  }
  .no-box {
    border: 0;
  }
}
</style>
